import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Calendar} from "primereact/calendar";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {CALENDAR_ES, MONTH_YEAR_FORMAT_CALENDAR} from "../../../utils/constants/Constants";
import InstitutionDropDown from "../../../components/dropDown/institution";
import {amountDataTableTemplate} from "../../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const Invoice = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Administración \ Facturación"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getInvoice}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item xs={12}>
                                    <div className="p-grid">
                                        <div className="p-col-3">
                                            <SubtitleLabel header="Fecha Inicial" isBold={true}/>
                                            <Calendar name="startDate"
                                                      view="month"
                                                      locale={CALENDAR_ES}
                                                      dateFormat={MONTH_YEAR_FORMAT_CALENDAR}
                                                      readOnlyInput={true}
                                                      value={props.filters.startDate}
                                                      onChange={props.onChangeFilters}
                                                      maxDate={props.filters.today}
                                                      monthNavigator={true}
                                                      yearNavigator={true}
                                                      yearRange={CALENDAR_ES['yearRange']}
                                                      showButtonBar={true}
                                            />
                                        </div>
                                        <div className="p-col-3">
                                            <SubtitleLabel header="Fecha Final" isBold={true}/>
                                            <Calendar name="finalDate"
                                                      view="month"
                                                      locale={CALENDAR_ES}
                                                      dateFormat={MONTH_YEAR_FORMAT_CALENDAR}
                                                      disabledDays={[0, 6]}
                                                      readOnlyInput={true}
                                                      value={props.filters.finalDate}
                                                      onChange={props.onChangeFilters}
                                                      minDate={props.filters.startDate}
                                                      maxDate={props.filters.today}
                                                      monthNavigator={true}
                                                      yearNavigator={true}
                                                      yearRange={CALENDAR_ES['yearRange']}
                                                      showButtonBar={true}
                                            />
                                        </div>
                                        <div className="p-col-3">
                                            <SubtitleLabel header="Instituciones" isBold={true}/>
                                            <InstitutionDropDown
                                                name="catInstitutionLenderFilter"
                                                filter="nombreCorto"
                                                save={props.onChangeFilters}
                                                value={props.filters.catInstitutionLenderFilter}
                                                loading={props.loading}
                                                placeholder={"Seleccione..."}
                                            />
                                        </div>
                                        <div className="p-col-3">
                                            <br/>
                                            <Button label="Limpiar"
                                                    style={{'float': 'right'}}
                                                    onClick={props.clearFilters}
                                                    className="p-button-secondary"/>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            label="Facturar"
                            style={{'float': 'right'}}
                            onClick={props.getInvoiceXls}
                            className="p-button-secondary"/>
                        <Button label="Expandir / Contraer" className="p-button-secondary"
                                style={{'float': 'right'}}
                                onClick={props.expandReduceAll}/>
                        <Button
                            label="Mtto. Instituciones"
                            style={{'float': 'right'}}
                            onClick={props.institutionsMaintenance}
                            className="p-button-secondary"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.invoiceList}
                            expandedRows={props.expandedRows}
                            onRowToggle={props.handleToggle}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            selection={props.selectedInvoice}
                            onSelectionChange={props.onSelectionChangeTable}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column expander={true} style={{width: '3em'}}/>
                            <Column
                                selectionMode="multiple"
                                style={{width: '4em'}}
                            />
                            <Column
                                field="facturado"
                                header="Facturado"
                                style={{textAlign: 'center'}}
                                body={props.invoiceIconDataTableTemplate}
                                sortable={true}
                            />
                            <Column
                                field="institucion"
                                header="Institución"
                                style={{textAlign: 'left'}}
                                body={props.formatInstitutionColumn}
                                sortable={true}
                            />
                            <Column
                                field="importe"
                                header="Importe"
                                style={{textAlign: 'right'}}
                                body={amountDataTableTemplate}
                                sortable={true}
                            />
                            <Column
                                field="iva"
                                header="Iva"
                                style={{textAlign: 'right'}}
                                body={amountDataTableTemplate}
                                sortable={true}
                            />
                            <Column
                                field="total"
                                header="Total"
                                style={{textAlign: 'right'}}
                                body={amountDataTableTemplate}
                                sortable={true}
                            />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default Invoice;